const cv = {
  profile: {
    name: "Pradeep Singh",
    title: "Senior Software Engineer | iOS & Mobile Architecture",
    location: "Chandigarh, India",
    availability: "Open to Relocation",
    phone: "+91-99881-98357",
    email: "prdpsingh402@gmail.com",
    linkedin: "https://www.linkedin.com/in/pradeep-singh-72092140",
    website: "https://pradeepapps.com",
    github: "https://github.com/prdpsingh402",
    medium: "https://medium.com/@prdpsingh402",
    credly: "https://www.credly.com/users/pradeep-singh.57750e3e/badges/credly",
    stackOverflow:
      "https://stackoverflow.com/users/8201371/pradeep-singh?tab=profile",
    languages: [
      { name: "English", level: "Fluent" },
      { name: "Hindi" },
      { name: "Punjabi" },
      { name: "French", level: "Beginner" },
    ],
  },

  summary:
    "Senior iOS Engineer with 11+ years of experience designing, developing, problem-solving, and deploying mobile and software solutions across iOS, Android, and cross-platform environments. Strong expertise in Mobile and Backend development, scalable application architecture, and enterprise mobile management. Experienced across the full software development lifecycle, technical leadership, mentoring, performance optimisation, and Agile/Scrum delivery. Combines hands-on mobile engineering with backend experience to deliver reliable products.",

  technicalSkills: [
    {
      category: "Native iOS",
      items: [
        "Swift",
        "SwiftUI",
        "UIKit",
        "Objective-C",
        "iOS SDK",
        "Combine",
        "Swift Concurrency",
        "async/await",
        "Localization",
        "Local Authentication (Face ID)",
        "Core Data",
        "Keychain",
        "WebView Integration",
        "JavaScript Bridges",
      ],
    },
    {
      category: "Architecture",
      items: [
        "MVVM",
        "MVC",
        "VIPER",
        "Multi-Target & Shared Codebases",
        "Xcode Schemes & Build Configurations",
        "Reusable Components",
        "Performance Optimization",
        "Multithreading",
        "SDLC",
        "OOP Principles",
      ],
    },
    {
      category: "Custom SDKs & iOS Frameworks",
      items: [
        "Custom SDKs",
        "Reusable iOS Frameworks",
        "Performance Tuning",
      ],
    },
    {
      category: "Cross-Platform",
      items: ["Flutter", "Dart", "React Native", "Kotlin", "Java"],
    },
    {
      category: "Offline Storage & Sync",
      items: [
        "Offline Storage",
        "Local Data Synchronization",
        "GRDB",
        "SwiftData",
      ],
    },
    {
      category: "Backend & APIs",
      items: [
        "REST APIs",
        "GraphQL",
        "Laravel (PHP)",
        "Node.js",
        "Express.js",
        "Firebase as a BaaS",
        "API Integration",
        "JSON",
        "Swagger",
        "Postman",
      ],
    },
    {
      category: "Cloud & DevOps",
      items: [
        "AWS (EC2, S3, RDS, ECR, IAM)",
        "Docker",
        "GitHub Actions",
        "CI/CD",
        "Fastlane",
      ],
    },
    {
      category: "Enterprise & Kiosks",
      items: [
        "Enterprise Kiosks",
        "JAMF MDM",
        "Managed App Distribution",
        "Managed App Configuration",
      ],
    },
    {
      category: "Payments",
      items: [
        "Stripe Payments",
        "Stripe SDK",
        "Tap to Pay on iPhone",
        "PayU API Integration",
      ],
    },
    {
      category: "Integrations & Messaging",
      items: [
        "Apple Push Notifications (APNs)",
        "Firebase Cloud Messaging (FCM)",
        "Twilio (SIP/softphone)",
        "Social Sign-in (Facebook, Google, Apple)",
        "Crashlytics Analytics",
      ],
    },
    {
      category: "Databases",
      items: [
        "PostgreSQL",
        "MySQL",
        "SQLite",
        "NoSQL",
        "Prisma ORM",
        "Firebase",
        "Supabase",
      ],
    },
    {
      category: "Tools & Version Control",
      items: [
        "Xcode",
        "Android Studio",
        "VS Code",
        "Cursor",
        "Git",
        "GitHub",
        "Bitbucket",
        "SourceTree",
        "Fastlane",
      ],
    },
    {
      category: "AI & Model Integration",
      items: [
        "Claude (Anthropic API)",
        "LLM-Powered App Features",
        "MCP-Based Workflows",
        "AI/LLM API Integration",
      ],
    },
    {
      category: "Testing & Quality",
      items: [
        "XCTest",
        "XCUITest",
        "Unit/UI Testing",
        "Automated Testing",
        "Debugging",
        "Code Reviews",
        "Code Coverage",
      ],
    },
    {
      category: "App Store & Release",
      items: [
        "App Store Connect",
        "TestFlight",
        "Production Release Support",
      ],
    },
    {
      category: "Delivery & Leadership",
      items: [
        "Requirements Analysis",
        "Mentoring",
        "Cross-Functional Collaboration",
        "Agile/Scrum Delivery",
      ],
    },
  ],

  experience: [
    {
      company: "UcodeSoft Solutions Pvt Ltd",
      location: "Mohali, India",
      title: "Senior Software Engineer (Mobile & Backend)",
      startDate: "2021-03",
      endDate: null,
      highlights: [
        "Led end-to-end development of mobile and software solutions across iOS, Android, Flutter, Laravel/PHP and mentored developers, strengthened engineering practices through code reviews, CI/CD, performance optimization, and full SDLC ownership.",
        "Optimized ICARUS OPS synchronization of 10,000+ server records by replacing excessive sequential API calls with a controlled six-request concurrency model and background processing, reducing synchronization time by ~70% from 30+ minutes to 8–10 minutes.",
        "Developed and supported enterprise Kiosk applications for Parking Organisation and operational workflows with responsibility of architecture, implementation, testing, deployment, and production maintenance.",
      ],
    },
    {
      company: "GoMad Infotech",
      location: "Mohali, India",
      title: "Senior Mobile Developer (iOS/Android/Flutter)",
      startDate: "2018-11",
      endDate: "2021-03",
      highlights: [
        "Developed and maintained native and cross-platform applications using Flutter, Swift, Kotlin, and Java, supporting multiple product and business requirements.",
        "Led UI/UX optimisation and implemented real-time analytics, push notifications, and mobile application integrations to improve application capability and user experience.",
      ],
    },
    {
      company: "NetSet Software Solutions Pvt Ltd",
      location: "Mohali, India",
      title: "Junior iOS Developer (iOS)",
      startDate: "2015-02",
      endDate: "2018-11",
      highlights: [
        "Built iOS applications using Objective-C and Swift, emphasising maintainable UI implementation, and stable application architecture.",
        "Developed reusable modules, supported application lifecycle management, and participated in code reviews to improve maintainability and code quality.",
        "Contributed to feature development, debugging, application maintenance, and continuous improvement across the product lifecycle.",
      ],
    },
  ],

  volunteerExperience: [
    {
      organization: "WE4U Trust",
      location: "Moradabad, India",
      title: "Volunteer Computer Teacher",
      startDate: "2012-06",
      endDate: "2014-12",
      website: "https://www.we4ungo.org",
      highlights: [
        "Provided basic computer education and practical training in Microsoft Office, internet usage, and essential digital skills to underserved communities.",
        "Developed teaching materials and supported learners through hands-on sessions, strengthening communication, mentoring through community engagements.",
      ],
    },
  ],

  projectHighlights: {
    intro:
      "Developed and contributed to 35+ mobile applications across government, aviation, smart-city parking, real estate, scientific research, and productivity domains. Several applications are live on the App Store, while others are enterprise and internal solutions; a few of them are listed below.",
    projects: [
      {
        name: "UMANG App (iOS Framework)",
        description: "Multi-service government platform.",
        url: "https://apps.apple.com/in/app/umang/id1236448857",
        highlights: [
          "Designed and developed a reusable iOS Framework for iPhone and iPad to support utility bill payments and recharge services such as electricity, water, gas, broadband, telephone, mobile, and DTH services.",
          "Integrated PayU APIs for payment processing and transaction workflows.",
          "Designed the framework for easy integration, reusability, and maintainability within the UMANG application.",
        ],
      },
      {
        name: "ICARUS OPS",
        description: "Aviation safety and operations management.",
        url: "https://apps.apple.com/in/app/icarus-ops/id1459253884",
        highlights: [],
      },
      {
        name: "Parklinq",
        description: "Smart City Parking Platform",
        url: null,
        highlights: [
          "Developed and maintained Enterprise iOS kiosk applications for parking validation, payment and enforcement workflows.",
          "Integrated Stripe Tap to Pay/payment workflows.",
          "Implemented enterprise deployment and configuration using JAMF MDM.",
          "Supported multiple application variants within the same ecosystem.",
        ],
      },
      {
        name: "Listerpros",
        description: "Real estate listing and scheduling application.",
        url: "https://apps.apple.com/us/app/listerpros/id6474097058",
        highlights: [],
      },
      {
        name: "PetDialog Studies App",
        description: "Pet data collection for scientific research.",
        url: "https://apps.apple.com/us/app/petdialog-studies-app/id1462174929",
        highlights: [],
      },
      {
        name: "iQadha",
        description:
          "Muslims calculate, track, and make up missed obligatory prayers and fasts.",
        url: "https://itunes.apple.com/us/app/iqadha/id1395338502?mt=8",
        highlights: [],
      },
    ],
  },

  certifications: [
    {
      name: "AWS Certified Cloud Practitioner",
      issuer: "AWS",
      issued: "2026-03-08",
      expires: "2029-03-08",
      url: "https://www.credly.com/badges/2d004254-32a6-4bdf-a3be-010ee2338828/public",
    },
    {
      name: "ISTQB® CTFL Certified",
      issuer: "Brightest",
      issued: "2026-04",
      expires: null,
      url: "https://www.credly.com/badges/9fd8aba9-34dc-4d8f-87ed-fd2ccf2a1ff6/public",
    },
    {
      name: "Professional Scrum Master™ I (PSM I)",
      issuer: "Scrum.org",
      issued: "2026-01",
      expires: null,
      url: "https://www.credly.com/badges/dc28fae1-3db9-4371-a579-a92fcc74e995/public",
    },
    {
      name: '"O" Level Certification',
      issuer: "NIELIT – Government of India",
      issued: "2017-03",
      expires: null,
      url: null,
    },
  ],

  leadershipAndRecognition: [
    {
      title: "External Viva Examiner, Lovely Professional University",
      description:
        "Served as an external viva examiner for software engineering students, evaluating final-year projects and conducting technical interviews.",
    },
    {
      title: "Recruitment Technical Lead, Internship Drive",
      description:
        "Spearheaded technical selection and onboarding of intern software engineers from private and public universities and colleges in their final semester.",
    },
  ],

  education: [
    {
      degree: "Master of Computer Applications",
      institution: "Sikkim Manipal University",
      year: 2015,
    },
    {
      degree: "Bachelor of Computer Applications",
      institution: "Punjab Technical University",
      year: 2012,
    },
  ],
};

export default cv;
